export default class AuthClient {
    constructor(apiClient) {
        this.usersUri = '/v3/users';
        this.tokensUri = '/v3/tokens';
        this.apiClient = apiClient;
        this.putUser = this.putUser.bind(this);
        this.getUsers = this.getUsers.bind(this);
        this.userExists = this.userExists.bind(this);
        this.getUser = this.getUser.bind(this);
        this.getUserVersions = this.getUserVersions.bind(this);
        this.userVersionExists = this.userVersionExists.bind(this);
        this.getUserVersion = this.getUserVersion.bind(this);
        this.postUserReset = this.postUserReset.bind(this);
        this.postUserResetCode = this.postUserResetCode.bind(this);
        this.resetTokenExists = this.resetTokenExists.bind(this);
        this.putUserResetToken = this.putUserResetToken.bind(this);
        this.putUsername = this.putUsername.bind(this);
        this.putUserPassword = this.putUserPassword.bind(this);
        this.postToken = this.postToken.bind(this);
        this.getTokens = this.getTokens.bind(this);
        this.getToken = this.getToken.bind(this);
        this.deleteToken = this.deleteToken.bind(this);
        this.deleteTokens = this.deleteTokens.bind(this);
        this.login = this.login.bind(this);
        this.logout = this.logout.bind(this);
        this.getPasswordConfig = this.getPasswordConfig.bind(this);
    }
    putUser(id, data, config) {
        return this.apiClient.put(`${this.usersUri}/${id}`, data, config);
    }
    getUsers(config) {
        return this.apiClient.get(`${this.usersUri}`, config);
    }
    userExists(idOrEmail, config) {
        return this.apiClient.exists(`${this.usersUri}/${idOrEmail}`, config);
    }
    getUser(id, config) {
        return this.apiClient.get(`${this.usersUri}/${id}`, config);
    }
    getUserVersions(id, config) {
        return this.apiClient.get(`${this.usersUri}/${id}/versions`, config);
    }
    userVersionExists(id, updateId, config) {
        return this.apiClient.exists(`${this.usersUri}/${id}/versions/${updateId}`, config);
    }
    getUserVersion(id, updateId, config) {
        return this.apiClient.get(`${this.usersUri}/${id}/versions/${updateId}`, config);
    }
    // postUserReset creates a reset token with a 24 hour expiration that can be used to activate or reset a password.
    //  The link sent to the user will have the user's email and reset token appended as query params.
    // Accepts a 'destination' query param to redirect the user after the reset token is used.
    postUserReset(idOrEmail, config) {
        return this.apiClient.post(`${this.usersUri}/${idOrEmail}/resets`, {}, config);
    }
    postUserResetCode(idOrEmail, config) {
        return this.apiClient.post(`${this.usersUri}/${idOrEmail}/reset_codes`, {}, config);
    }
    resetTokenExists(idOrEmail, resetToken, config) {
        return this.apiClient.exists(`${this.usersUri}/${idOrEmail}/resets/${resetToken}`, config);
    }
    // Set a password using a reset token
    putUserResetToken(idOrEmail, resetToken, data, config) {
        return this.apiClient.put(`${this.usersUri}/${idOrEmail}/resets/${resetToken}`, data, config);
    }
    // Updates the users email
    putUsername(id, data, config) {
        return this.apiClient.put(`${this.usersUri}/${id}/usernames`, data, config);
    }
    putUserPassword(id, data, config) {
        return this.apiClient.put(`${this.usersUri}/${id}/passwords`, data, config);
    }
    // postToken calls login and is the same as the /login route in the service
    postToken(data, config) {
        return this.apiClient.post(`${this.tokensUri}`, data, Object.assign(Object.assign({}, config), { withCredentials: true }));
    }
    getTokens(config) {
        return this.apiClient.get(`${this.tokensUri}`, config);
    }
    getToken(id, config) {
        return this.apiClient.get(`${this.tokensUri}/${id}`, Object.assign(Object.assign({}, config), { withCredentials: true }));
    }
    deleteToken(id, config) {
        return this.apiClient.delete(`${this.tokensUri}/${id}`, Object.assign(Object.assign({}, config), { withCredentials: true }));
    }
    deleteTokens(config) {
        return this.apiClient.delete(`${this.tokensUri}/`, Object.assign(Object.assign({}, config), { withCredentials: true }));
    }
    login(data, config) {
        return this.apiClient.post('/v3/login', data, Object.assign(Object.assign({}, config), { withCredentials: true }));
    }
    logout(config) {
        return this.apiClient.delete('/v3/logout', Object.assign(Object.assign({}, config), { withCredentials: true }));
    }
    getPasswordConfig(config) {
        return this.apiClient.get('/v3/password_config', config);
    }
    ssoRedirect(ssoRedirect, config) {
        return this.apiClient.post('/v3/saml/redirect', ssoRedirect, config);
    }
}
